/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import type { Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectHasTourAvailability } from '../../../../modules/multifamilyTourTimePicker/selectors/index'
import { useGetTourIntegration } from './useGetTourIntegration'

export const useHasInstantTourBooking = (
  entity:
    | MaybeEmpty<Pick<Property, 'groupId' | 'isTourDisabled' | 'mightHaveInstantTourScheduling'>>
    | Pin<RawPinInventorySearch>
    | null
    | undefined,
  skip?: boolean
) => {
  const { fetched, fetching } = useGetTourIntegration(entity, skip)
  const hasTourAvailability = useSelector(
    (state) => !!entity?.groupId && selectHasTourAvailability(state, entity.groupId)
  )
  return useMemo(
    () => ({
      fetching,
      hasInstantTourAvailability: fetched ? hasTourAvailability : undefined,
    }),
    [fetched, fetching, hasTourAvailability]
  )
}
